// extracted by mini-css-extract-plugin
module.exports = {"modal__heading":"deleteModal_modal__heading__2tI_-","modal__remainbutton":"deleteModal_modal__remainbutton__3M5gE","modal__deletebutton":"deleteModal_modal__deletebutton__2WTYJ"};